import * as jamespotUserApi from 'jamespot-user-api';
import * as React from 'react';
import * as reactDnd from 'react-dnd';
import * as reactDndHtml5Backend from 'react-dnd-html5-backend';
import * as ReactDOM from 'react-dom';
import * as reactHookForm from 'react-hook-form';
import * as reactIntl from 'react-intl';
import * as reactReduxLib from 'react-redux';
import * as reactRouterDom from 'react-router-dom';
import * as reactSelect from 'react-select';
import * as reduxLib from 'redux';
import * as reduxFormLib from 'redux-form';
import * as styled from 'styled-components';

/****
 * DECLARE SHARED LIBRARIES ON GLOBAL
 */

declare global {
    interface Window {
        React: any;
        ReactDOM: any;
        jamespotUserApi: any;
        reactRedux: any;
        redux: any;
        reduxForm: any;
        reactIntl: any;
        reactSelect: any;
        styledComponents: any;
        reactDnd: any;
        reactDndHtml5Backend: any;
        reactHookForm: any;
        reactRouterDom: any;
    }
}

window.React = React;
window.ReactDOM = ReactDOM;

window.jamespotUserApi = jamespotUserApi;
window.reactRedux = reactReduxLib;
window.redux = reduxLib;
window.reduxForm = reduxFormLib;
window.reactIntl = reactIntl;
window.reactSelect = reactSelect;
window.styledComponents = styled;
window.reactDnd = reactDnd;
window.reactDndHtml5Backend = reactDndHtml5Backend;
window.reactHookForm = reactHookForm;
window.reactRouterDom = reactRouterDom;

/****
 *
 * PLEASE RESPECT ALPHABETICAL ORDER
 *
 */

export { default as Theme } from './styles/theme';
export { default as Resources } from './translation';

export { JRC404 } from './components/404';
export { BETA_JRCDoubleClick } from './components/Beta/BETA_JRCDoubleClick/BETA_JRCDoubleClick';
export { BETA_JRCDragAndDrop } from './components/Beta/BETA_JRCDragAndDrop/BETA_JRCDragAndDrop';
export { DashedFocusBorder } from './components/Common/DashedFocusBorder';
export { JRCConditionalWrapper } from './components/Common/JRCConditionalWrapper';
export { JRCDraggingPlaceholder } from './components/Common/JRCDraggingPlaceholder';
export { JRCDriveDropbox } from './components/Drives/JRCDriveDropbox';
export { JRCDriveMSGraph } from './components/Drives/JRCDriveMSGraph';
export { ClickAwayListener } from './components/Form/Common/ClickAwayListener';
export { JRCFormAutocompleteAudienceField } from './components/Form/Input/Deprecated/JRCFormAutocomplete/JRCFormAutocompleteAudience';
export { JRCFormAutocompleteCommunityField } from './components/Form/Input/Deprecated/JRCFormAutocomplete/JRCFormAutocompleteCommunity';
export { JRCFormAutocompleteTaxonomyField } from './components/Form/Input/Deprecated/JRCFormAutocomplete/JRCFormAutocompleteTaxonomy';
export { JRCFormCheckbox } from './components/Form/Input/Deprecated/JRCFormCheckbox/JRCFormCheckbox';
export { JRCFormColorField } from './components/Form/Input/Deprecated/JRCFormColor/JRCFormColor';
export { JRCFormEmailField } from './components/Form/Input/Deprecated/JRCFormEmail/JRCFormEmail';
export { JRCFormInputFileField } from './components/Form/Input/Deprecated/JRCFormFile/JRCFormFile';
export {
    JRCFormInputImage,
    JRCFormInputImageField,
} from './components/Form/Input/Deprecated/JRCFormImage/JRCFormImage';
export { JRCFormNumberField } from './components/Form/Input/Deprecated/JRCFormNumber/JRCFormNumber';
export { JRCFormRangeField } from './components/Form/Input/Deprecated/JRCFormRange/JRCFormRange';
export { JRCFormReceiveACopyField } from './components/Form/Input/Deprecated/JRCFormReceiveACopy/JRCFormReceiveACopy';
export { JRCFormRichTextField } from './components/Form/Input/Deprecated/JRCFormRichText/JRCFormRichTextField';
export { JRCFormSelectField, JRCFormSelectInput } from './components/Form/Input/Deprecated/JRCFormSelect/JRCFormSelect';
export { JRCFormSelectTagField } from './components/Form/Input/Deprecated/JRCFormSelect/JRCFormSelectTag';
export { JRCFormSendAlertField } from './components/Form/Input/Deprecated/JRCFormSendAlert/JRCFormSendAlert';
export { JRCFormTextField } from './components/Form/Input/Deprecated/JRCFormText/JRCFormText';
export {
    JRCFormTextarea,
    JRCFormTextareaField,
} from './components/Form/Input/Deprecated/JRCFormTextarea/JRCFormTextarea';
export { JRCFormUrlField } from './components/Form/Input/Deprecated/JRCFormURL/JRCFormUrl';
export { JRCCheckbox } from './components/Form/Input/JRCInputCheckbox/components/JRCCheckbox';
export { JRCInputCheckbox, JRCInputCheckboxRaw } from './components/Form/Input/JRCInputCheckbox/JRCInputCheckbox';
export { JRCInputReorderCheckbox } from './components/Form/Input/JRCInputCheckbox/JRCInputReorderCheckbox';
export { JRCInputToggle, JRCInputToggleRaw } from './components/Form/Input/JRCInputCheckbox/JRCInputToggle';
export { JRCInputColor } from './components/Form/Input/JRCInputColor/JRCInputColor';
export { JRCInputColorRaw } from './components/Form/Input/JRCInputColor/JRCInputColorRaw';
export { JRCInputDate } from './components/Form/Input/JRCInputDate/JRCInputDate';
export { JRCInputDateTime } from './components/Form/Input/JRCInputDateTime/JRCInputDateTime';
export { JRCInputEmail } from './components/Form/Input/JRCInputEmail/JRCInputEmail';
export { JRCInputFile } from './components/Form/Input/JRCInputFile/JRCInputFile';
export { JRCInputFileAdvancedRaw } from './components/Form/Input/JRCInputFileAdvanced/JRCInputFileAdvancedRaw';
export { JRCInputImage } from './components/Form/Input/JRCInputImage/JRCInputImage';
export { JRCInputSearchRaw } from './components/Form/Input/JRCInputSearchRaw/JRCInputSearchRaw';
export { JRCInputPassword } from './components/Form/Input/JRCInputText/JRCInputPassword';
export { JRCInputNumber, JRCInputText } from './components/Form/Input/JRCInputText/JRCInputText';
export { JRCInputTextIconButton } from './components/Form/Input/JRCInputText/JRCInputTextIconButton';
export { JRCInputTextarea } from './components/Form/Input/JRCInputTextarea/JRCInputTextarea';
export { JRCInputTextareaRaw } from './components/Form/Input/JRCInputTextarea/JRCInputTextareaRaw';
export { JRCInputTextRaw } from './components/Form/Input/JRCInputTextRaw/JRCInputTextRaw';
export { JRCInputTime } from './components/Form/Input/JRCInputTime/JRCInputTime';
export { JRCInputTinyMCE } from './components/Form/Input/JRCInputTinyMCE/JRCInputTinyMCE';
export { JRCInputTinyMCERaw } from './components/Form/Input/JRCInputTinyMCERaw/JRCInputTinyMCERaw';
export { JRCTinyMCEFileUploadModal } from './components/Form/Input/JRCInputTinyMCERaw/JRCTinyMCEFileUploadModal';
export { JRCTinyMCEImageUploadModal } from './components/Form/Input/JRCInputTinyMCERaw/JRCTinyMCEImageUploadModal';
export { JRCTinyMCEVideoUploadModal } from './components/Form/Input/JRCInputTinyMCERaw/JRCTinyMCEVideoUploadModal';
export { JRCInputUrl } from './components/Form/Input/JRCInputUrl/JRCInputUrl';
export { JRCInputCommunity } from './components/Form/Input/JRCSelect/JRCAutocompleteCommunity';
export { JRCInputAudience } from './components/Form/Input/JRCSelect/JRCInputAudience';
export { JRCInputAutocomplete } from './components/Form/Input/JRCSelect/JRCInputAutocomplete';
export { JRCInputSelect } from './components/Form/Input/JRCSelect/JRCInputSelect';
export { JRCInputSelectExtended } from './components/Form/Input/JRCSelect/JRCInputSelectExtended';
export { JRCInputSelectHierarchicalTree } from './components/Form/Input/JRCSelect/JRCInputSelectHierarchicalTree';
export { JRCInputSelectList } from './components/Form/Input/JRCSelect/JRCInputSelectList';
export { JRCInputSelectRaw } from './components/Form/Input/JRCSelect/JRCInputSelectRaw';
export { JRCAlert } from './components/JRCAlert/JRCAlert';
export { JRCAppContainer } from './components/JRCAppContainer/JRCAppContainer';
export { JRCAppHeader } from './components/JRCAppHeader/JRCAppHeader';
export { JRCAppLeftColumn } from './components/JRCAppLeftColumn/JRCAppLeftColumn';
export { JRCAttachments } from './components/JRCAttachments/JRCAttachments';
export { JRCAvatar } from './components/JRCAvatar/JRCAvatar';
export { JRCButton } from './components/JRCButton/JRCButton';
export { JRCValidationButton } from './components/JRCButton/JRCValidationButton';
export { JRCButtonDownload } from './components/JRCButtonDownload/JRCButtonDownload';
export { JRCButtonDropdown } from './components/JRCButtonDropdown/JRCButtonDropdown';
export { JRCButtonFile } from './components/JRCButtonFile/JRCButtonFile';
export { JRCCard } from './components/JRCCard/JRCCard';
export { JRCCardImg } from './components/JRCCard/JRCCardImg';
export { JRCCollapse } from './components/JRCCollapse/JRCCollapse';
export { JRCColumnCenter } from './components/JRCColumnCenter/JRCColumnCenter';
export { JRCColumnLeft } from './components/JRCColumnLeft/JRCColumnLeft';
export { JRCColumnRight } from './components/JRCColumnRight/JRCColumnRight';
export { JRCCommentsBloc } from './components/JRCCommentsBloc/JRCCommentsBloc';
export { JRCCropImage } from './components/JRCCropImage/JRCCropImage';
export { JRCDate } from './components/JRCDate/JRCDate';
export { JRCDisplayCard } from './components/JRCDisplayCard/JRCDisplayCard';
export { JRCDropDown } from './components/JRCDropDown/JRCDropDown';
export { JRCEllipsis } from './components/JRCEllipsis/JRCEllipsis';
export { JRCEmptySpace } from './components/JRCEmptySpace/JRCEmptySpace';
export { JRCFile } from './components/JRCFile/JRCFile';
export { JRCFileAvatar } from './components/JRCFile/JRCFileAvatar';
export { JRCFileOpen } from './components/JRCFileOpen/JRCFileOpen';
export { JRCFileViewer } from './components/JRCFileViewer/JRCFileViewer';
export { JRCFlexBox } from './components/JRCFlex/JRCFlexBox';
export { JRCFolders } from './components/JRCFolders/JRCFolders';
export { JRCGrid } from './components/JRCGrid/JRCGrid';
export { JRCStyledHref } from './components/JRCHref/JRCHref';
export { JRCHtml } from './components/JRCHtml/JRCHtml';
export { JRCIcon } from './components/JRCIcon/JRCIcon';
export { JRCIconButton } from './components/JRCIconButton/JRCIconButton';
export { JRCImg } from './components/JRCImg/JRCImg';
export { JRCList } from './components/JRCList/JRCList';
export { JRCLoader } from './components/JRCLoader/JRCLoader';
export { JRCMenu } from './components/JRCMenu/JRCMenu';
export { JRCMessage } from './components/JRCMessage/JRCMessage';
export { JRCModalContent } from './components/JRCModal/JRCModalContent';
export { JRCModalContentForm } from './components/JRCModal/JRCModalContentForm';
export { JRCModalLayout } from './components/JRCModal/JRCModalLayout';
export { JRCModal } from './components/JRCModal/templates/JRCModal';
export { JRCModalForm } from './components/JRCModal/templates/JRCModalForm';
export { JRCModalImg } from './components/JRCModalImg/JRCModalImg';
export { JRCPagination } from './components/JRCPagination/JRCPagination';
export { JRCSidePanelModal } from './components/JRCSidePanelModal/JRCSidePanelModal';
export { JRCSkeletonLine } from './components/JRCSkeleton/JRCSkeletonLine';
export { JRCSkeletonList } from './components/JRCSkeleton/JRCSkeletonList';
export { JRCSkeletonSquare } from './components/JRCSkeleton/JRCSkeletonSquare';
export { JRCTabPanel, JRCTabs } from './components/JRCTabs/JRCTabs';
export { JRCTag } from './components/JRCTag/JRCTag';
export { JRCThemeProvider } from './components/JRCThemeProvider/JRCThemeProvider';
export { JRCBaseTooltip } from './components/JRCTooltip/JRCBaseTooltip';
export { JRCTooltip } from './components/JRCTooltip/JRCTooltip';
export { JRCH1, JRCH2, JRCH3, JRCH4, JRCH5, JRCText } from './components/JRCTypo/JRCTypo';
export { JRCTypography } from './components/JRCTypography/JRCTypography';
export { JRCUserPopup } from './components/JRCUserPopup/JRCUserPopup';
export { JRCPageNotLogged } from './components/Pages/JRCPageNotLogged';
export { JRCFadeStepper } from './components/Stepper/JRCFadeStepper';
export { JRCImageStepper } from './components/Stepper/JRCImageStepper';
export { JRCStepper } from './components/Stepper/JRCStepper';
export { JRCAppColumn } from './components/Templates/JRCAppColumn';
export { JRCTemplateBase } from './components/Templates/JRCBase.template';
export { JRCBasicAutoMarginContainer } from './components/Templates/JRCBasicAutoMarginContainer';
export { JRCColumn } from './components/Templates/JRCColumn';
export { JRCContainer } from './components/Templates/JRCContainer';
export { JRCMainColumn } from './components/Templates/JRCMainColumn';
export { JRCPanel } from './components/Templates/JRCPanel';
export { JRCStepperPage } from './components/Templates/JRCStepperPage';
export { JRCTemplateTwoColumns } from './components/Templates/JRCTwoColumns.template';

export { JRCProgressBar } from './components/JRCProgressBar/JRCProgressBar';

export { JRCWidgetArticleAttachmentEditor } from './components/Widgets/JRCWidgetAttachment/JRCWidgetArticleAttachmentEditor';
export { JRCWidgetAttachment } from './components/Widgets/JRCWidgetAttachment/JRCWidgetAttachment';

export { JRCWidgetButton } from './components/Widgets/JRCWidgetButton/JRCWidgetButton';
export { JRCWidgetButtonEditor } from './components/Widgets/JRCWidgetButton/JRCWidgetButtonEditor';

export { JRCWidgetArticleGallery } from './components/Widgets/JRCWidgetArticleGallery/JRCWidgetArticleGallery';
export { JRCWidgetArticleGalleryEditor } from './components/Widgets/JRCWidgetArticleGallery/JRCWidgetArticleGalleryEditor';

export { JRCWidgetArticleImageEditor } from './components/Widgets/JRCWidgetImage/JRCWidgetArticleImageEditor';
export { JRCWidgetImage } from './components/Widgets/JRCWidgetImage/JRCWidgetImage';
export { JRCWidgetImageEditor } from './components/Widgets/JRCWidgetImage/JRCWidgetImageEditor';

export { JRCWidgetArticleText } from './components/Widgets/JRCWidgetArticleText/JRCWidgetArticleText';
export { JRCWidgetArticleTextEditor } from './components/Widgets/JRCWidgetArticleText/JRCWidgetArticleTextEditor';

export { JRCWidgetArticleTitle } from './components/Widgets/JRCWidgetArticleTitle/JRCWidgetArticleTitle';
export { JRCWidgetArticleTitleEditor } from './components/Widgets/JRCWidgetArticleTitle/JRCWidgetArticleTitleEditor';

export { JRCWidgetDatasourceTableEditor } from './components/Widgets/JRCWidgetTable/JRCWidgetDatasourceTableEditor';
export { JRCWidgetExcelDatasourceTableEditor } from './components/Widgets/JRCWidgetTable/JRCWidgetExcelDatasourceTableEditor';
export { JRCWidgetTable } from './components/Widgets/JRCWidgetTable/JRCWidgetTable';
export { JRCWidgetTableEditor } from './components/Widgets/JRCWidgetTable/JRCWidgetTableEditor';

export { JRCWidgetArticleSliderEditor } from './components/Widgets/JRCWidgetSlider/JRCWidgetArticleSliderEditor'; // dedcated slider component editor for article
export { JRCWidgetSlider } from './components/Widgets/JRCWidgetSlider/JRCWidgetSlider'; // standalone slider component

export { JRCWidgetEmptyInplace } from './components/Widgets/JRCWidgetEmptyInplace';

export { JRCWidgetLuccaAbsence } from './components/Widgets/JRCWidgetLuccaAbsence/JRCWidgetLuccaAbsence';
export { JRCWidgetLuccaAbsenceEditor } from './components/Widgets/JRCWidgetLuccaAbsence/JRCWidgetLuccaAbsenceEditor';

export { JRCWidgetCheckList } from './components/Widgets/JRCWidgetCheckList/JRCWidgetCheckList';
export { JRCWidgetCheckListEditor } from './components/Widgets/JRCWidgetCheckList/JRCWidgetCheckListEditor';

export { JRCWidgetPresence } from './components/Widgets/JRCWidgetPresence/JRCWidgetPresence';
export { JRCWidgetPresenceEditor } from './components/Widgets/JRCWidgetPresence/JRCWidgetPresenceEditor';

export { JRCWidgetQuickSurvey } from './components/Widgets/JRCWidgetQuickSurvey/JRCWidgetQuickSurvey';
export { JRCWidgetQuickSurveyEditor } from './components/Widgets/JRCWidgetQuickSurvey/JRCWidgetQuickSurveyEditor';

export { JRCWidgetCalendarCalDav } from './components/Widgets/JRCWidgetCalendarCalDav/JRCWidgetCalendarCalDav';
export { JRCWidgetCalendarCalDavEditor } from './components/Widgets/JRCWidgetCalendarCalDav/JRCWidgetCalendarCalDavEditor';
export { JRCWidgetContactCardDav } from './components/Widgets/JRCWidgetContactCardDav/JRCWidgetContactCardDav';
export { JRCWidgetContactCardDavEditor } from './components/Widgets/JRCWidgetContactCardDav/JRCWidgetContactCardDavEditor';
export { JRCWidgetEmailsImap } from './components/Widgets/JRCWidgetEmailsImap/JRCWidgetEmailsImap';
export { JRCWidgetEmailsImapEditor } from './components/Widgets/JRCWidgetEmailsImap/JRCWidgetEmailsImapEditor';
export { JRCWidgetEmailsImapLevel2 } from './components/Widgets/JRCWidgetEmailsImap/JRCWidgetEmailsImapLevel2';

export { JRCWidgetIcon } from './components/Widgets/JRCWidgetIcon';

export { JRCModalUserList } from './components/JRCModalUserList/JRCModalUserList';

export { LabelDescriptionOption } from './components/Form/Input/JRCSelect/JRCInputSelect.defaults';
export { StyledInput } from './components/Form/Input/JRCStyledInput';

export { useAbortController } from './hooks/useAbortController';
export { useCancelOnUnmount } from './hooks/useCancelOnUnmount';
export { useDebounce } from './hooks/UseDebounce';
export { useDidMountEffect } from './hooks/UseDidMountEffect';
export { useImageLoader } from './hooks/UseImageLoader';
export { useKeyPress } from './hooks/UseKeyPress';
export { useRefSize } from './hooks/useRefSize';
export { useTimeout } from './hooks/UseTimeout';
export { useWindowSize } from './hooks/useWindowSize';

export { JTinyMCEExtensionsBuilders } from './components/Form/Input/JRCInputTinyMCERaw/extensions/JTinyMCEExtensions';

/****
 *
 * PLEASE RESPECT ALPHABETICAL ORDER
 *
 */

// Export Types
export * from './types';

// Export Utils
export { Utils } from './utils';
